var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function TruckDeliveryIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 7L15.5 5.99896C15.5 5.44725 15.9439 5 16.5 5C17.0523 5 17.5 5.44913 17.5 5.99896V7H18.5C18.9226 7 19.2996 7.26568 19.4418 7.66369L20.9903 12H22.0014C22.5529 12 23 12.4485 23 13.0029V17.9971C23 18.551 22.5517 19 22.0013 19H20.8293C20.4175 20.1652 19.3062 21 18 21C16.6938 21 15.5825 20.1652 15.1707 19H8.82929C8.41746 20.1652 7.30622 21 6 21C4.69378 21 3.58254 20.1652 3.17071 19H1.99875C1.44715 19 1 18.5554 1 17.9991V4.00087C1 3.44811 1.45081 3 2.00043 3H12.9996C13.5521 3 14.0001 3.44631 14.0001 3.99754L14.0006 7H14.5ZM14.0009 9L14.0013 12H18.8668L17.7958 9H14.0009ZM18 15C19.3062 15 20.4175 15.8348 20.8293 17H21V14H12.9987C12.4471 14 12 13.5537 12 13.0025V5H3V17H3.17071C3.58254 15.8348 4.69378 15 6 15C7.30622 15 8.41746 15.8348 8.82929 17H15.1707C15.5825 15.8348 16.6938 15 18 15ZM19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18ZM7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18Z",
    fill: ""
  }));
}
export var TruckDeliveryIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: TruckDeliveryIconInner
  }, props));
};